import { Component } from '@angular/core';

@Component({
    selector: 'app-skeleton-loader-lead-list',
    templateUrl: './skeleton-loader-lead-list.component.html',
    styleUrl: './skeleton-loader-lead-list.component.scss',
    standalone: false
})
export class SkeletonLoaderLeadListComponent {
}
